import {funcGoCardlessMandateManager} from '@/plugins/axios';

export const postGoCardlessStart = (payload, taskId) => {
  return funcGoCardlessMandateManager.post(`gocardless/${taskId}/start?code=${process.env.VUE_APP_FUNC_GOCARDLESSFUNCTIONKEY}`, payload);
};  

export const postGoCardlessComplete = (payload, taskId, billingRequestId) => {
  return funcGoCardlessMandateManager.post(`gocardless/${taskId}/complete?billing_request_id=${billingRequestId}&code=${process.env.VUE_APP_FUNC_GOCARDLESSFUNCTIONKEY}`, payload);
};  